<template>
    <div class="mt-2">
        <b-form-select
            v-model="option"
            :options="clientGroupOptions"
            size="sm"
            :class="selectClass"
            @change="setFilter"
        />
    </div>
</template>

<script>
import { mapState } from 'vuex'
import DataUpdater from '../../../dashboard/mixins/DataUpdater.vue'

export default {
    name: 'SelectClientGroup',

    mixins: [DataUpdater],

    data() {
        return {
            option: 0
        }
    },

    computed: {
        ...mapState({
            filters: (state) => state.reportingVM.filters,
            filterOptions: (state) => state.data.options
        }),

        clientGroupOptions() {
            return this.filterOptions.clientGroups.filter(item => item.value !== null)
        },

        selectClass() {
            return this.option === 0
                ? 'bg-white'
                : 'bg-info text-primary font-weight-bold'
        }
    },

    created() {
        this.option = this.filters.clientGroup
    },

    methods: {
        async setFilter() {
            await this.$store.dispatch(
                'reportingVM/setClientGroupFilter',
                this.option
            )
            this.$emit('client-group-has-changed')
            this.updateData()
            await this.$store.dispatch('reportingVM/refreshCounters')
        }
    }
}
</script>

<style scoped></style>
